import { render, staticRenderFns } from "./PostCreate.vue?vue&type=template&id=4bc1d441&scoped=true&"
import script from "./PostCreate.vue?vue&type=script&lang=ts&"
export * from "./PostCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PostCreate.vue?vue&type=style&index=0&id=4bc1d441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1d441",
  null
  
)

export default component.exports